// App.js
import React from 'react';
import { Calendar } from 'primereact/calendar';
import 'primeicons/primeicons.css';
import './YearlyHoliday.css';
import Holiday from "./HolidayCalender.module.css"
import { useCommon } from '../../../Hooks/Common/useCommon';
import { useCalendar } from '../../../Hooks/Features/Calendar/useCalendar';
import { FutureyearsOptions, timePickerMuiCss } from '../../../utils/Helper';
import { Dropdown } from 'primereact/dropdown';
import { Dialog } from 'primereact/dialog'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AgGridReact } from '@ag-grid-community/react';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import DatePicker, { DateObject } from 'react-multi-date-picker';
import _ from 'underscore';
import CalendarConfig from './CalendarConfig';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import CommonFilterDropdown from '../../../components/CommonCompo/CommonFilterDropdown/CommonFilterDropdown';

const YearlyHolidayCalender = () => {
  const { checkPermission } = useCommon();
  const { tagRef, getHolidayCalender, filterValues, setFilterValues, groupOption, dateTemplate, rowData, updateHolidayPopup, setUpdateHolidayPopup, handleChange, holidayType, dayTypeOption, updatedData, handleSelctedDate
    , upsertHolidayCalender, selectView, setSelectView, columnDefs, mappedData, edit, setEdit, editData, setEditData, handleUpsertCalendarHours, showCalendarConfig, setShowCalendarConfig, showGenerateCalendar, setShowGenerateCalendar } = useCalendar();



  const generateCalendarForMonth = (month) => {
    const monthStartDate = new Date(filterValues?.year, month, 1);
    const monthEndDate = new Date(filterValues?.year, month + 1, 0);
    const calendarDate = new Date(filterValues?.year, month, 1);

    return (
      <div className="month mb-2">
        <Calendar
          value={calendarDate}
          inline
          minDate={monthStartDate}
          maxDate={monthEndDate}
          dateTemplate={dateTemplate}
          onChange={handleSelctedDate}
          showOtherMonths={false}
        />
      </div>
    );
  };


  return (
    <div className="" ref={() => checkPermission('Holiday Calender', tagRef)}>
      <div className='row'>

        <div className="col-4">
          <h5>Calendar</h5>
        </div>
        <div className='col-2'>
          <Dropdown
            onChange={(e) => setFilterValues((prev) => ({ ...prev, year: e.target.value }))}
            onHide={() => { if (!_.isEmpty(filterValues?.day_calendar_groups)) { getHolidayCalender() } }}
            options={FutureyearsOptions}
            placeholder="Year"
            value={filterValues?.year}
            optionLabel="label"
          />
        </div>
        <div className='col-2'>
          <CommonFilterDropdown
            fields={[
              { key: "day_calendar_groups", label: "Unit", col: 12, type: 'dropdown', showClear: false },
            ]}
            filterValues={filterValues}
            setFilterValues={setFilterValues}
          />
        </div>
        <div className={`col-4 text-right`}>
          <button className="button btn-default" title='Configuration' onClick={() => { setShowCalendarConfig(true); }} >
            <FontAwesomeIcon icon="fa-solid fa-sliders" />
          </button>
          {selectView === "list" &&
            <button className="button btn-default" title='Edit Day Hours' onClick={() => { setEditData({ date: [new DateObject(new Date()?.setFullYear(filterValues?.year)), new DateObject(new Date()?.setFullYear(filterValues?.year))], hours: "", shift_start: "", shift_end: "" }); setEdit(true) }} >
              <FontAwesomeIcon icon="fa-solid fa-pen-to-square" />
            </button>
          }
          <button className={`button ${selectView === "week" ? "btn-primary" : "btn-default"} `} onClick={() => setSelectView("week")} >
            <FontAwesomeIcon icon="fa-solid fa-calendar" />
          </button>
          <button className={`button ${selectView === "list" ? "btn-primary" : "btn-default"} `} onClick={() => setSelectView("list")}>
            <FontAwesomeIcon icon="fa-solid fa-list" />
          </button>

        </div>
      </div>
      <hr></hr>
      {
        rowData?.length > 0 && <>
          {
            selectView === "week" ? <div className="year-calendar" ref={tagRef} id='{"tabname": "Holiday Calender", "data": "holiday_calendar_tab"}' style={{ height: "calc(100vh - 120px)", overflow: 'auto' }}>
              {Array.from({ length: 12 }).map((_, index) => (
                <React.Fragment key={index}>{generateCalendarForMonth(index)}</React.Fragment>
              ))}
            </div> : <div className="ag-theme-alpine custom-grid mt-1" style={{ height: "calc(100vh - 120px)" }}>
              <AgGridReact
                columnDefs={columnDefs}
                rowData={mappedData}
                rowHeight={30}
                headerHeight={30}
              />
            </div>
          }</>
      }
      <Dialog header="Update" visible={updateHolidayPopup} style={{ width: '30vw' }}
        onHide={() => { if (!updateHolidayPopup) return; setUpdateHolidayPopup(false); }} draggable={false}>
        <div>
          <div className='row'>
            <div className='col-6'>
              <label className='holiday-lable'>Select Date</label>
              <div className='inspectra-calendar'>
                <Calendar
                  className='input-dd'
                  dateFormat='dd-mm-yy'
                  placeholder="day date"
                  name='day_date'
                  value={updatedData?.day_date}
                  onChange={(e) => { handleSelctedDate(e); handleChange(e) }} />
              </div>
            </div>
            <div className='col-6'>
              <label className='holiday-lable'> Day Type</label>
              <Dropdown
                onChange={handleChange}
                value={updatedData?.day_type_id}
                options={dayTypeOption}
                optionLabel="day_type_name"
                placeholder={holidayType}
                className={`${Holiday["dropdown"]} input-dd`}
                name='day_type_id' />
            </div>
            <div className='col-6'>
              <label className='holiday-lable'> Name</label>
              <input style={{ width: "100%" }} type='text' placeholder='Add Holiday Name' name="description" value={updatedData?.description} onChange={handleChange} className='input-dd' />
            </div>
            <div className='col-6'>
              <label className='holiday-lable'>Work hours</label>
              <input style={{ width: "100%" }} type="number" min={0} defaultValue={updatedData.day_hours} name="day_hours" placeholder="Work hours" onChange={handleChange} className='input-dd' />
            </div>
            <div className='col-6'>
              <label className='holiday-lable'>Shift Start</label>
              <div className='inspectra-calendar'>
                <TimePicker label="Shift Start" value={updatedData?.shift_start || null} onChange={(e) => handleChange(e, false, "shift_start")} sx={{ ...timePickerMuiCss, backgroundColor: "white" }}
                  slotProps={{
                    textField: {
                      label: undefined,
                    }
                  }}
                />
              </div>
            </div>
            <div className='col-6'>
              <label className='holiday-lable'>Shift End</label>
              <div className='inspectra-calendar'>
                <TimePicker label="Shift Start" value={updatedData?.shift_end || null} onChange={(e) => handleChange(e, false, "shift_end")} sx={{ ...timePickerMuiCss, backgroundColor: "white" }}
                  slotProps={{
                    textField: {
                      label: undefined,
                    }
                  }}
                />
              </div>
            </div>
            <div className='col-6 mx-2 d-flex align-items-center gap-1'>
              <input type='checkbox' id='master-checkbox' checked={updatedData?.is_active} onChange={(e) => handleChange(e, true)} name="is_active" />
              <label className='holiday-lable'>Active</label>
            </div>
          </div>

          <div className='d-flex justify-content-end'>
            <button onClick={upsertHolidayCalender}>Submit</button>
          </div>
        </div>
      </Dialog>

      <Dialog header="Calendar Config" visible={showCalendarConfig} draggable={false} className='modal-large profile-dialog' onHide={() => { setShowCalendarConfig(false) }} style={{ height: "80vh" }}>
        <CalendarConfig dayTypeOption={dayTypeOption} FutureyearsOptions={FutureyearsOptions} groupOption={groupOption} getHolidayCalender={(year, unit) => getHolidayCalender(year, unit)} />
      </Dialog>

      <Dialog visible={edit} header="Edit Multiple Day hours/shift" onHide={() => { setEdit(false); setEditData({ date: [new DateObject(new Date()?.setFullYear(filterValues?.year)), new DateObject(new Date()?.setFullYear(filterValues?.year))], hours: "", shift_start: "", shift_end: "" }) }} draggable={false} className='modal-small'>
        <div>
          <div>
            <DatePicker portal zIndex={99999} placeholder='Select Date Range' range rangeHover value={editData?.date} onChange={(e) => {
                                            if (!e || e.length === 2) {
                                                setEditData((prev) => ({ ...prev, date: e }));
                                            }
                                        }} format="DD-MM-YYYY" />
          </div>
          <div className='d-flex gap-5 mt-2 align-items-center'>
            <div className='w25'>
              <input className='input-text w100' placeholder='Hours' value={editData?.hours} onChange={(e) => setEditData((prev) => ({ ...prev, hours: e.target.value, shift_start: e.target.value ? "" : prev?.shift_start, shift_end: e.target.value ? "" : prev?.shift_end }))} />
            </div>
            <div>OR</div>
            <div className='d-flex gap-3 w50'>
              <div className='w50'>
                <TimePicker label="Shift Start" value={editData?.shift_start || null} onChange={(e) => setEditData((prev) => ({ ...prev, shift_start: e, hours: e ? "" : prev?.hours }))} sx={{ ...timePickerMuiCss, backgroundColor: "white" }}
                  slotProps={{
                    textField: {
                      label: undefined,
                    }
                  }}
                />
              </div>
              <div className='w50'>
                <TimePicker label="Shift End" value={editData?.shift_end || null} onChange={(e) => setEditData((prev) => ({ ...prev, shift_end: e, hours: e ? "" : prev?.hours }))} sx={{ ...timePickerMuiCss, backgroundColor: "white" }}
                  slotProps={{
                    textField: {
                      label: undefined,
                    }
                  }}
                />
              </div>
            </div>
          </div>
          <div className='text-right mt-2'>
            <button className="button btn-primary" onClick={() => handleUpsertCalendarHours()} >Submit</button>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default YearlyHolidayCalender;